export const language = window ? (window.defaults ? window.defaults.language : "en") : "en";
export const frontendUrl = window ? (window.defaults ? window.defaults.frontendUrl : "/") : "/";
export const absFrontendUrl = window ? (window.defaults ? window.defaults.absFrontendUrl : "/") : "/";
export const backendUrl = window ? (window.defaults ? window.defaults.backendUrl : "/") : "/";
export const apiUrl = window ? (window.defaults ? window.defaults.apiUrl : "/") : "/";
